import type { ReactNode} from 'react';
import { createContext, useContext, useState } from 'react';

interface InvoiceBlobContextType {
  blobUrlBlobMap: Record<string, Blob | undefined>;
  blobUrlUploadedMap: Record<string, boolean>;
  setBlobUrlBlobMap: React.Dispatch<
    React.SetStateAction<Record<string, Blob | undefined>>
  >;
  setBlobUrlUploadedMap: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
}

const InvoiceBlobContext = createContext<InvoiceBlobContextType | undefined>({
  blobUrlBlobMap: {},
  blobUrlUploadedMap: {},
  setBlobUrlBlobMap: () => {},
  setBlobUrlUploadedMap: () => {},
});

export const InvoiceBlobContextProvider = ({
  children,
  initialBlobUrlBlobMapState = {},
  initialBlobUrlUploadedMap = {},
}: {
  children: ReactNode;
  initialBlobUrlBlobMapState?: Record<string, Blob | undefined>;
  initialBlobUrlUploadedMap?: Record<string, boolean>;
}) => {
  const [blobUrlBlobMap, setBlobUrlBlobMap] = useState<
    Record<string, Blob | undefined>
  >(initialBlobUrlBlobMapState);
  const [blobUrlUploadedMap, setBlobUrlUploadedMap] = useState<
    Record<string, boolean>
  >(initialBlobUrlUploadedMap);

  return (
    <InvoiceBlobContext.Provider
      value={{
        blobUrlBlobMap,
        setBlobUrlBlobMap,
        blobUrlUploadedMap,
        setBlobUrlUploadedMap,
      }}
    >
      {children}
    </InvoiceBlobContext.Provider>
  );
};

export const useInvoiceBlobContext = (): InvoiceBlobContextType => {
  const context = useContext(InvoiceBlobContext);
  if (!context) {
    throw new Error(
      'useInvoiceBlobContext must be used within a InvoiceBlobContextProvider'
    );
  }
  return context;
};

export default InvoiceBlobContext;
